import { render } from "./RangeSlider.vue?vue&type=template&id=4f52664e"
import script from "./RangeSlider.vue?vue&type=script&lang=js"
export * from "./RangeSlider.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__